import {
  MyBooking,
  MyBookingStatusUpdate,
  PagedMyBooking,
  PagedResult,
  Result,
} from "@models";
import requests from "./agent";

export const bookingService = {
  getMyBookings: async (request: PagedMyBooking) => {
    const response = await requests.get<Result<PagedResult<MyBooking>>>(
      "/api/services/app/Booking/GetMyBookings",
      { params: request }
    );
    return response.result;
  },

  updateMyBookingStatus: async (request: MyBookingStatusUpdate) => {
    await requests.put(
      "api/services/app/Booking/UpdateMyBookingStatus",
      request
    );
  },
};
